import { useId, useSyncExternalStore } from 'react';
import courtyardArt from './gate/courtyards.webp';
import courtyardOff from './gate/courtyards-off.webp';

// The accepted illustration is one matched pair; each scene displays its own half.
const width = 836;
const height = 941;
const reducedMotionQuery = '(prefers-reduced-motion: reduce)';
const motionSnapshot = () => window.matchMedia(reducedMotionQuery).matches;
const motionServerSnapshot = () => true;
function subscribeMotion(onChange) {
  const query = window.matchMedia(reducedMotionQuery);
  query.addEventListener('change', onChange);
  return () => query.removeEventListener('change', onChange);
}

export default function CourtyardGateScene({ fantasy = false, selected = false }) {
  const sceneId = `gate-courtyard-${useId().replace(/[^a-zA-Z0-9_-]/g, '')}`;
  const reducedMotion = useSyncExternalStore(subscribeMotion, motionSnapshot, motionServerSnapshot);
  const animateBanner = fantasy && selected && !reducedMotion;
  const imageX = fantasy ? -width : 0;
  return <svg
    className={`presentation-courtyard-scene ${fantasy ? 'presentation-fantasy-scene' : 'presentation-community-scene'}`}
    viewBox={`0 0 ${width} ${height}`}
    preserveAspectRatio={fantasy ? 'xMaxYMid slice' : 'xMidYMid slice'}
    aria-hidden="true"
    focusable="false"
  >
    <defs>
      <filter id={`${sceneId}-soft-edge`}><feGaussianBlur stdDeviation="3" /></filter>
      <mask id={`${sceneId}-lighting`} maskUnits="userSpaceOnUse" x="0" y="450" width={width} height="300">
        {/* Reveal the actual lit windows and their light on the path, not a glow drawn over the facade. */}
        <path d={fantasy ? 'M497 539H598V678H497Z M437 580H466V638H437Z M646 570H676V638H646Z M732 570H758V636H732Z M490 663L604 663L665 733L416 733Z' : 'M181 559H373V627H181Z M451 506H630V638H451Z M701 560H822V625H701Z M464 627L611 627L676 715L364 715Z'} fill="white" filter={`url(#${sceneId}-soft-edge)`} />
      </mask>
      {fantasy && <>
        <mask id={`${sceneId}-cloth`} maskUnits="userSpaceOnUse" x="711" y="308" width="76" height="249">
          <path d="M713 317L778 310L780 551L748 521L713 551Z" fill="white" />
        </mask>
        <filter id={`${sceneId}-wind`} filterUnits="userSpaceOnUse" x="685" y="298" width="128" height="280" colorInterpolationFilters="sRGB">
          <feTurbulence type="fractalNoise" baseFrequency=".012 .012" numOctaves="1" seed="8" result="wind">
            {animateBanner && <animate attributeName="baseFrequency" values=".012 .012;.016 .009;.012 .012" dur="3.6s" repeatCount="indefinite" />}
          </feTurbulence>
          <feDisplacementMap in="SourceGraphic" in2="wind" scale={animateBanner ? 13 : 0} xChannelSelector="R" yChannelSelector="G">
            {animateBanner && <animate attributeName="scale" values="6;18;9;6" dur="3.6s" repeatCount="indefinite" />}
          </feDisplacementMap>
        </filter>
      </>}
    </defs>
    <image className="presentation-courtyard-art" href={courtyardOff} x={imageX} width={width * 2} height={height} />
    <image className="presentation-courtyard-lit" href={courtyardArt} x={imageX} width={width * 2} height={height} mask={`url(#${sceneId}-lighting)`} />
    {fantasy && <g className="presentation-courtyard-banner" data-animated={animateBanner}>
      {animateBanner && <animateTransform attributeName="transform" type="rotate" values="0 746 314;4 746 314;-3 746 314;0 746 314" dur="3.6s" repeatCount="indefinite" />}
      {/* Filter after masking: the cloth silhouette moves against a clean background. */}
      <g filter={`url(#${sceneId}-wind)`}><g mask={`url(#${sceneId}-cloth)`}>
        <image href={courtyardArt} x={imageX} width={width * 2} height={height} />
      </g></g>
    </g>}
  </svg>;
}
